// extracted by mini-css-extract-plugin
module.exports = {"tip":"RestoreForm_tip__vu4Ut","success":"RestoreForm_success__ptktn","recovery_icon":"RestoreForm_recovery_icon___Czye","submitButton":"RestoreForm_submitButton__DOxDE"};